import { IPayer, PayerType } from '@alberta/konexi-shared';
import { ISearchable } from 'src/app/common/contracts/components/searchable';

import { AggregateRoot } from '../aggregate-root';

export class PayerDto extends AggregateRoot implements IPayer, ISearchable {
  type: PayerType;
  ikNumber: string;
  name: string;
  phone: string;
  fax: string;
  email: string;
  website: string;
  address: string;
  postalCode: string;
  city: string;

  constructor() {
    super();
  }

  get displayText(): string {
    return this.name;
  }
}
